import type { TabSwitchTypes } from '@genial/components';
import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useState } from 'react';

import { SpreadsheetDownload } from '../components/SpreadsheetDownload';
import { SpreadsheetImport } from '../components/SpreadsheetImport';
import { SpreadsheetRequests } from '../components/SpreadsheetRequests';

const redeemTabOptions = [
  {
    key: 'import-spreadsheet',
    label: 'Importar planilha',
    component: (
      <VStack flex={1} py={Spacing['stack.xxs']}>
        <SpreadsheetImport />
      </VStack>
    ),
  },
  {
    key: 'my-requests',
    label: 'Minhas solicitações',
    component: (
      <VStack flex={1} py={Spacing['stack.xxs']} space={Spacing['inline.xxxs']}>
        <SpreadsheetDownload />
        <SpreadsheetRequests />
      </VStack>
    ),
  },
] as const;

export type RedeemTabKeyOptions = (typeof redeemTabOptions)[number]['key'];

export const useRedeemTabs = () => {
  const [selectedTab, setSelectedTab] = useState<RedeemTabKeyOptions>(redeemTabOptions[0].key);
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const handleSelectTab = (value: RedeemTabKeyOptions) => {
    setSelectedTab(value);
  };

  const tabSwitchProps = {
    testId: 'redeem-tab-switch',
    tabs: redeemTabOptions,
    selectedTab,
    onTabPress: handleSelectTab,
    isMobile,
  } as unknown as TabSwitchTypes.Props;

  return tabSwitchProps;
};
